interface CardProps {
    title: string;
    onClick?: () => void;
    selected?: boolean;
    imageSrc?: string;
    size?: 'default' | 'small';  // Nuova prop per dimensioni
  }

  export const Card: React.FC<CardProps> = ({ title, selected, onClick, imageSrc, size = 'default' }) => (
    <div onClick={onClick} className={`${size === 'small' ? 'w-[100px] sm:w-[120px] gap-y-2 p-2 sm:p-3 rounded-2xl' : 'w-[150px] sm:w-56 gap-y-4 p-4 sm:p-6 md:p-8 rounded-3xl'} flex flex-col items-center justify-center select-none border-b-4 border-fpcred ${!selected ? "bg-white" : "bg-fpcpink text-fpcred"} shadow-lg cursor-pointer transform transition duration-300 hover:scale-105`}>
      {imageSrc && <img src={imageSrc} alt={title} className={`${size === 'small' ? 'w-12 h-12 sm:w-16 sm:h-16 mb-1' : 'w-24 h-24 mb-2'}`} />}
      <div className="text-center">
        <p className={`font-bold ${size === 'small' ? 'text-xs sm:text-sm leading-tight' : 'text-lg sm:text-xl md:text-2xl'}`}>{title}</p>
      </div>
    </div>
  );
